import {TableButtonOptions} from "../../../Modules/ListPage/Components/Table/Buttons/TableButtonGroup";
import {ProfileButton} from "../../../Modules/ListPage/Components/Table/Buttons/ProfileButton";
import React from "react";


const USER_SCHEMA_NAME = 'usuario-integracao';

export const UserIntegrationCustomSchema = (name, schema) => {
    const endpoint = `${process.env.REACT_APP_NODE_SERVICE}/auth/integration-users/`;
    console.log('Customizando user list schema', name, schema)
    if (!(name === USER_SCHEMA_NAME)) {
        return;
    }

    schema.getEndpoint = () => {
        return endpoint;
    }

    schema.getColumns = () => {
        return [
            TableButtonOptions({
                deleteEndpoint: endpoint,
                width: 250,
                children: ({row}) => {
                    return [
                        <ProfileButton key={"edit_" + row.id} row={row} isIntegrationUser={true}/>,
                    ]
                }
            }),
            {
                header: 'Nome',
                accessorKey: 'name',
            },
            {
                header: 'Nome do Usuário',
                accessorKey: 'email',
            },
            {
                header: 'Ativo',
                accessorKey: 'activated',
                type: 'boolean',
                cell: ({row}) => {
                    return row.original.activated ? 'Ativo' : 'Inátivo'
                }
            }
        ]
    }
}


export const UserIntegrationCustomFormSchema = (name, schema) => {
    if (!(name === USER_SCHEMA_NAME)) {
        return;
    }


    schema.uiSchema = {}


    schema.getFormSchema = (name, params) => {
        const formSchema = {
            type: 'object',
            properties: {
                name: {
                    title: 'Nome',
                    type: "string",
                },
                activated: {
                    title: 'Ativo',
                    type: "boolean",
                    default: true,
                },
                email: {
                    title: 'Nome do Usuário',
                    type: "string",
                    //format: "email",
                    default: crypto.randomUUID()
                },
                password: {
                    type: "string",
                 //   format: 'password',
                    title: "Senha",
                    "minLength": 6,
                    default: crypto.randomUUID()
                }
            },
            required: ['name', 'email'],

        };
        const {id} = params;

        if (id) {
            delete formSchema.properties.email
            formSchema.required = formSchema.required.filter(x => x !== 'email')
        }

        return formSchema;
    }


    schema.getSaveUrl = (id) => {
        return `${process.env.REACT_APP_NODE_SERVICE}auth/integration-users/${id || ''}`;
    }

    schema.getByIdUrl = (id) => `${process.env.REACT_APP_NODE_SERVICE}auth/integration-users/${id}`;

    schema.formatObjectToSave = (formData) => {
        return formData;
    };


}
